import { createFileRoute } from "@tanstack/react-router";
import { optionParam, textParam } from "@/utils/searchParams";

/** Which slice of the queue is on screen. In the URL, so leaving the page and
 *  coming back keeps it (NAV-45) — and so "the four still open" is a link
 *  somebody can paste into a message. */
export const BUG_REPORT_STATES = ["open", "addressed"] as const;
export type BugReportState = (typeof BUG_REPORT_STATES)[number];

export type AdminBugReportsSearch = {
  q?: string;
  state?: BugReportState;
};

export const Route = createFileRoute("/admin/bug-reports")({
  validateSearch: (search: Record<string, unknown>): AdminBugReportsSearch => ({
    q: textParam(search.q),
    state: optionParam(BUG_REPORT_STATES, search.state),
  }),
});
